type AnyRecord<T> = Record<keyof T, T[keyof T]>;
type StringEnum = Record<string, string>;

type Reverse<T extends AnyRecord<T>> = {
  [Value in T[keyof T]]: keyof T;
};

type EnumMap<T1 extends StringEnum, T2 extends Record<keyof T1, string | number>> = {
  [Value in T1[keyof T1]]: T2[keyof T2];
};

export function mapEnums<T1 extends StringEnum, T2 extends Record<keyof T1, string | number>>(
  a: T1,
  b: T2
) {
  return {
    original: Object.fromEntries(
      Object.entries(a).map(([aKey, aValue]) => [aValue, b[aKey]])
    ) as EnumMap<T1, T2>,
    reverse: Object.fromEntries(
      Object.entries(a).map(([aKey, aValue]) => [b[aKey], aValue])
    ) as Reverse<EnumMap<T1, T2>>,
  };
}
